var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-textarea',{attrs:{"value":_vm.value,"label":_vm.label,"light":"","outlined":""},on:{"input":_vm.handleInput}})}
var staticRenderFns = []

export { render, staticRenderFns }